// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"20587d50","188":"312ec649","277":"8ecea104","488":"3eabe148","525":"4012f55f","619":"9c522796"}[chunkId] + ".chunk.js";
};